import requestIdleCallback from '../shims/requestIdleCallback';

class ReadMore {
    root: HTMLElement;
    options: Options;
    btn: HTMLButtonElement;

    constructor( el: HTMLElement, options: Options ) {
        this.root = el;

        if ( !this.root.parentNode ) {
            throw new ReferenceError( '[parentNode] not defined' );
        }

        this.options = Object.assign( {}, ReadMore.defaultOptions, options );

        this.root.classList.add( this.options.shortenClass || ReadMore.defaultOptions.shortenClass );

        this.btn = document.createElement<'button'>( 'button' );
        this.btn.className = 'readmore-link bold d-inline-flex flex-align-center';
        this.btn.innerHTML = `<svg viewbox="0 0 10 10" width="10" height="10" class="v-fill v-fill-blue mr-xs"><use xlink:href="#icon-plus" /></svg><strong class="readmore-txt">${this.options.readMoreText}</strong>`;
        this.btn.addEventListener( 'click', this.onClick.bind( this ) );

        this.root.parentNode.appendChild( this.btn );

        this.root.dataset.tsReadmoreDone = 'true';
    }

    onClick() {
        this.root.classList.remove( this.options.shortenClass || ReadMore.defaultOptions.shortenClass );

        requestIdleCallback( () => {
            this.btn.remove();
        } );

        if ( this.options.onClicked ) {
            this.options.onClicked();
        }
    }

    static defaultOptions = {
        // These are the defaults.
        textLimit: 600,
        // text limit from where we want to hide
        renderAttr: 'ts-readmore-done',
        // attribute to control read more button has been added
        shortenClass: 'readmore-shorten',
        // class to short text by css
        readMoreText: 'Read More',
    };
}

interface Options {
    textLimit?: number;
    renderAttr?: string;
    shortenClass?: string;
    readMoreText: string;
    onClicked?: () => void,
}

export function initReadMore( element: HTMLElement, options: Options = ReadMore.defaultOptions ): ReadMore | null {
    if ( element.textContent && element.textContent.length < ( options.textLimit || ReadMore.defaultOptions.textLimit ) ) {
        return null;
    }

    if ( element.dataset.tsReadmoreDone && element.dataset.tsReadmoreDone === 'true' ) {
        return null;
    }

    return new ReadMore( element, options );
}
